import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomeTransitability from "@/components/HomeTransitability";

export default function TransitabilityPage() {
  return (
    <>
      <Header />
      <main className="max-w-[1600px] mx-auto px-4 md:px-6 py-8" data-testid="transitability-page">
        <div className="border-b pb-5 mb-6" style={{ borderColor: "var(--border)" }}>
          <p className="overline accent-text mb-2">SERVICIO PÚBLICO</p>
          <h1 className="font-headline uppercase text-4xl md:text-6xl">Transitabilidad</h1>
          <p className="mt-3 text-sm" style={{ color: "var(--text-muted)" }}>
            Estado actual de las rutas en Bolivia · Fuente: ABC
          </p>
        </div>
        <HomeTransitability variant="full" />
      </main>
      <Footer />
    </>
  );
}
